// extracted by mini-css-extract-plugin
export default {"previewImage":"FrontBackSelfieButton_previewImage__cyFnE"};